'use client';
"use strict";

var _excluded = ["index"],
    _excluded2 = ["children"],
    _excluded3 = ["descendants"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;

var __export = function __export(target, all) {
  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
};

var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
        _step;

    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return to;
};

var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
}; // src/index.ts


var src_exports = {};

__export(src_exports, {
  PinInput: function PinInput() {
    return _PinInput;
  },
  PinInputDescendantsProvider: function PinInputDescendantsProvider() {
    return _PinInputDescendantsProvider;
  },
  PinInputField: function PinInputField() {
    return _PinInputField;
  },
  PinInputProvider: function PinInputProvider() {
    return _PinInputProvider;
  },
  usePinInput: function usePinInput() {
    return _usePinInput;
  },
  usePinInputContext: function usePinInputContext() {
    return _usePinInputContext;
  },
  usePinInputField: function usePinInputField() {
    return _usePinInputField;
  }
});

module.exports = __toCommonJS(src_exports); // src/pin-input.tsx

var import_system = require("@chakra-ui/system");

var import_shared_utils2 = require("@chakra-ui/shared-utils");

var import_react_children_utils = require("@chakra-ui/react-children-utils"); // src/use-pin-input.ts


var import_descendant = require("@chakra-ui/descendant");

var import_react_use_controllable_state = require("@chakra-ui/react-use-controllable-state");

var import_shared_utils = require("@chakra-ui/shared-utils");

var import_react_context = require("@chakra-ui/react-context");

var import_react_use_merge_refs = require("@chakra-ui/react-use-merge-refs");

var import_react = require("react");

var _ref = (0, import_descendant.createDescendantContext)(),
    _ref2 = _slicedToArray(_ref, 4),
    _PinInputDescendantsProvider = _ref2[0],
    usePinInputDescendantsContext = _ref2[1],
    usePinInputDescendants = _ref2[2],
    usePinInputDescendant = _ref2[3];

var _ref3 = (0, import_react_context.createContext)({
  name: "PinInputContext",
  errorMessage: "usePinInputContext: `context` is undefined. Seems you forgot to all pin input fields within `<PinInput />`"
}),
    _ref4 = _slicedToArray(_ref3, 2),
    _PinInputProvider = _ref4[0],
    _usePinInputContext = _ref4[1];

var toArray = function toArray(value) {
  return value == null ? void 0 : value.split("");
};

function validate(value, type) {
  var NUMERIC_REGEX = /^[0-9]+$/;
  var ALPHA_NUMERIC_REGEX = /^[a-zA-Z0-9]+$/i;
  var regex = type === "alphanumeric" ? ALPHA_NUMERIC_REGEX : NUMERIC_REGEX;
  return regex.test(value);
}

function _usePinInput() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var autoFocus = props.autoFocus,
      value = props.value,
      defaultValue = props.defaultValue,
      _onChange = props.onChange,
      onComplete = props.onComplete,
      _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === void 0 ? "\u25CB" : _props$placeholder,
      _props$manageFocus = props.manageFocus,
      manageFocus = _props$manageFocus === void 0 ? true : _props$manageFocus,
      _props$otp = props.otp,
      otp = _props$otp === void 0 ? false : _props$otp,
      idProp = props.id,
      isDisabled = props.isDisabled,
      isInvalid = props.isInvalid,
      _props$type = props.type,
      type = _props$type === void 0 ? "number" : _props$type,
      mask = props.mask;
  var uuid = (0, import_react.useId)();
  var id = idProp != null ? idProp : "pin-input-".concat(uuid);
  var descendants = usePinInputDescendants();

  var _ref5 = (0, import_react.useState)(true),
      _ref6 = _slicedToArray(_ref5, 2),
      moveFocus = _ref6[0],
      setMoveFocus = _ref6[1];

  var _ref7 = (0, import_react.useState)(-1),
      _ref8 = _slicedToArray(_ref7, 2),
      focusedIndex = _ref8[0],
      setFocusedIndex = _ref8[1];

  var _ref9 = (0, import_react_use_controllable_state.useControllableState)({
    defaultValue: toArray(defaultValue) || [],
    value: toArray(value),
    onChange: function onChange(values2) {
      return _onChange == null ? void 0 : _onChange(values2.join(""));
    }
  }),
      _ref10 = _slicedToArray(_ref9, 2),
      values = _ref10[0],
      setValues = _ref10[1];

  (0, import_react.useEffect)(function () {
    if (autoFocus) {
      var first = descendants.first();

      if (first) {
        requestAnimationFrame(function () {
          first.node.focus();
        });
      }
    }
  }, [descendants]);
  var focusNext = (0, import_react.useCallback)(function (index) {
    if (!moveFocus || !manageFocus) return;
    var next = descendants.next(index, false);

    if (next) {
      requestAnimationFrame(function () {
        next.node.focus();
      });
    }
  }, [descendants, moveFocus, manageFocus]);
  var setValue = (0, import_react.useCallback)(function (value2, index) {
    var handleFocus = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    var nextValues = _toConsumableArray(values);

    nextValues[index] = value2;
    setValues(nextValues);
    var isComplete = value2 !== "" && nextValues.length === descendants.count() && nextValues.every(function (inputValue) {
      return inputValue != null && inputValue !== "";
    });

    if (isComplete) {
      onComplete == null ? void 0 : onComplete(nextValues.join(""));
    } else {
      if (handleFocus) focusNext(index);
    }
  }, [values, setValues, focusNext, onComplete, descendants]);
  var clear = (0, import_react.useCallback)(function () {
    var _a;

    var values2 = Array(descendants.count()).fill("");
    setValues(values2);
    var first = descendants.first();
    (_a = first == null ? void 0 : first.node) == null ? void 0 : _a.focus();
  }, [descendants, setValues]);
  var getNextValue = (0, import_react.useCallback)(function (value2, eventValue) {
    var nextValue = eventValue;

    if ((value2 == null ? void 0 : value2.length) > 0) {
      if (value2[0] === eventValue.charAt(0)) {
        nextValue = eventValue.charAt(1);
      } else if (value2[0] === eventValue.charAt(1)) {
        nextValue = eventValue.charAt(0);
      }
    }

    return nextValue;
  }, []);
  var getInputProps = (0, import_react.useCallback)(function (props2) {
    var index = props2.index,
        rest = _objectWithoutProperties(props2, _excluded);

    var onChange2 = function onChange2(event) {
      var eventValue = event.target.value;
      var currentValue = values[index];
      var nextValue = getNextValue(currentValue, eventValue);

      if (nextValue === "") {
        setValue("", index);
        return;
      }

      if (eventValue.length > 2) {
        if (validate(eventValue, type)) {
          var nextValue2 = eventValue.split("").filter(function (_, index2) {
            return index2 < descendants.count();
          });
          setValues(nextValue2);

          if (nextValue2.length === descendants.count()) {
            onComplete == null ? void 0 : onComplete(nextValue2.join(""));
          }
        }
      } else {
        if (validate(nextValue, type)) {
          setValue(nextValue, index);
        }

        setMoveFocus(true);
      }
    };

    var onKeyDown = function onKeyDown(event) {
      var _a;

      if (event.key === "Backspace" && manageFocus) {
        if (event.target.value === "") {
          var prevInput = descendants.prev(index, false);

          if (prevInput) {
            setValue("", index - 1, false);
            (_a = prevInput.node) == null ? void 0 : _a.focus();
            setMoveFocus(true);
          }
        } else {
          setMoveFocus(false);
        }
      }
    };

    var onFocus = function onFocus() {
      setFocusedIndex(index);
    };

    var onBlur = function onBlur() {
      setFocusedIndex(-1);
    };

    var hasFocus = focusedIndex === index;
    var inputType = type === "number" ? "tel" : "text";
    return _objectSpread(_objectSpread({
      "aria-label": "Please enter your pin code",
      inputMode: type === "number" ? "numeric" : "text",
      type: mask ? "password" : inputType
    }, rest), {}, {
      id: "".concat(id, "-").concat(index),
      disabled: isDisabled,
      "aria-invalid": (0, import_shared_utils.ariaAttr)(isInvalid),
      onChange: (0, import_shared_utils.callAllHandlers)(rest.onChange, onChange2),
      onKeyDown: (0, import_shared_utils.callAllHandlers)(rest.onKeyDown, onKeyDown),
      onFocus: (0, import_shared_utils.callAllHandlers)(rest.onFocus, onFocus),
      onBlur: (0, import_shared_utils.callAllHandlers)(rest.onBlur, onBlur),
      value: values[index] || "",
      autoComplete: otp ? "one-time-code" : "off",
      placeholder: hasFocus ? "" : placeholder
    });
  }, [descendants, focusedIndex, getNextValue, id, isDisabled, mask, isInvalid, manageFocus, onComplete, otp, placeholder, setValue, setValues, type, values]);
  return {
    // prop getter
    getInputProps: getInputProps,
    // state
    id: id,
    descendants: descendants,
    values: values,
    // actions
    setValue: setValue,
    setValues: setValues,
    clear: clear
  };
}

function _usePinInputField() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var _usePinInputContext2 = _usePinInputContext(),
      getInputProps = _usePinInputContext2.getInputProps;

  var _usePinInputDescendan = usePinInputDescendant(),
      index = _usePinInputDescendan.index,
      register = _usePinInputDescendan.register;

  return getInputProps(_objectSpread(_objectSpread({}, props), {}, {
    ref: (0, import_react_use_merge_refs.mergeRefs)(register, ref),
    index: index
  }));
} // src/pin-input.tsx


var import_react2 = require("react");

var import_jsx_runtime = require("react/jsx-runtime");

function _PinInput(props) {
  var styles = (0, import_system.useStyleConfig)("PinInput", props);

  var _ref11 = (0, import_system.omitThemingProps)(props),
      children = _ref11.children,
      rest = _objectWithoutProperties(_ref11, _excluded2);

  var _usePinInput2 = _usePinInput(rest),
      descendants = _usePinInput2.descendants,
      context = _objectWithoutProperties(_usePinInput2, _excluded3);

  var clones = (0, import_react_children_utils.getValidChildren)(children).map(function (child) {
    return (0, import_react2.cloneElement)(child, {
      __css: styles
    });
  });
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(_PinInputDescendantsProvider, {
    value: descendants,
    children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(_PinInputProvider, {
      value: context,
      children: clones
    })
  });
}

_PinInput.displayName = "PinInput";

var _PinInputField = (0, import_system.forwardRef)(function PinInputField2(props, ref) {
  var inputProps = _usePinInputField(props, ref);

  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_system.chakra.input, _objectSpread(_objectSpread({}, inputProps), {}, {
    className: (0, import_shared_utils2.cx)("chakra-pin-input", props.className)
  }));
});

_PinInputField.displayName = "PinInputField"; // Annotate the CommonJS export names for ESM import in node:

0 && (module.exports = {
  PinInput: _PinInput,
  PinInputDescendantsProvider: _PinInputDescendantsProvider,
  PinInputField: _PinInputField,
  PinInputProvider: _PinInputProvider,
  usePinInput: _usePinInput,
  usePinInputContext: _usePinInputContext,
  usePinInputField: _usePinInputField
});